module.exports = __webpack_public_path__ + "static/img/nc.0f8fe742.svg";